import { render, staticRenderFns } from "./phoneRecruit.vue?vue&type=template&id=6be61dca"
import script from "./phoneRecruit.vue?vue&type=script&lang=js"
export * from "./phoneRecruit.vue?vue&type=script&lang=js"
import style0 from "./phoneRecruit.vue?vue&type=style&index=0&id=6be61dca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports